import { Select, SelectProps } from 'antd';

import { Picker } from '@app/web-components';

import { useFindProductFamily } from '../../data';

export const ProductFamilyInput = (props: Omit<SelectProps, 'loading' | 'options'>) => {
  const { search, getSelectProps } = Picker.usePicker();
  const { data, isFetching, isPending } = useFindProductFamily({ nameSearch: search, pageSize: 50, startIndex: 0 });

  return (
    <Select
      {...getSelectProps({
        ...props,
        loading: isPending || isFetching,
        placeholder: props?.placeholder ?? 'Type in product family',
      })}
      options={data?.map((x) => ({ label: x.name, value: x.id }))}
    />
  );
};
